import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Injectable } from '@angular/core';

import { Destination } from '@app/criterion-addition/shared/models/destination.models';
import { CriterionAdditionApiRoute } from '@app/core/models/api.models';
import { CriterionAdditionApiService } from '@app/core/api/customers/criterion-addition/criterion-addition-api.service';
import { RuleLevel } from '@app/criterion-addition/shared/models/rule.models';
import { CompositeId } from '@app/core/models/common.models';
import { objectCamelCaseToSnake } from '@app/core/utilities/string.utilities';

export type DestinationGetParams =
  | { ruleTypeId: number; ruleLevel: RuleLevel.Platform }
  | { ruleTypeId: number; ruleLevel: RuleLevel.Account; ruleAdspertAccountId: number }
  | { ruleTypeId: number; ruleLevel: RuleLevel.Campaign; ruleAdspertCampaignId: CompositeId }
  | { ruleTypeId: number; ruleLevel: RuleLevel.AdGroup; ruleAdspertAdgroupId: CompositeId }
  | { proposalId: number };

@Injectable({
  providedIn: 'root',
})
export class DestinationTypeApiService extends CriterionAdditionApiService {
  readonly criterionAdditionRoute = CriterionAdditionApiRoute.DestinationTypes;

  getTypes(params: DestinationGetParams): Observable<Destination[]> {
    return this.getList<Destination>({ disablePaging: true, params: objectCamelCaseToSnake(params) }).pipe(
      map(({ data }) => data),
    );
  }
}
